import { FileSystemItemModel } from "client/Api/Documents/WebDav/webDav";
import * as pubsub from "pubsub-js";

enum WebDavEvent {
	// When 1 or multiple items are deleted
	Deleted = "document.webdav.deleted",
	// When 1 item was created or replaced
	CreatedOrReplaced = "document.webdav.createdOrReplaced",
	// When 1 item was renamed
	Renamed = "document.webdav.renamed",
	// When 1 item was moved
	Moved = "document.webdav.moved",
}

type Data<T extends WebDavEvent> =
	T extends WebDavEvent.Deleted ? { serverId: number; documentIds: readonly string[]; } :
	T extends WebDavEvent.CreatedOrReplaced ? { serverId: number; item: FileSystemItemModel; } :
	T extends WebDavEvent.Renamed ? { serverId: number; oldItemId: string; item: FileSystemItemModel; } :
	T extends WebDavEvent.Moved ? { serverId: number; oldItemId: string; item: FileSystemItemModel; } :
	never;

export const subscribe: <T extends WebDavEvent>(kind: T, callback: (message: string, data: Data<T>) => void) => PubSubSubscriptionToken = pubsub.subscribe;
export const publish: <T extends WebDavEvent>(kind: T, data: Data<T>) => void = pubsub.publish;
export const unsubscribe: (token: PubSubSubscriptionToken) => void = pubsub.unsubscribe;
export {
	WebDavEvent
};
